import script from "./radioInput.vue?vue&type=script&setup=true&lang=js"
export * from "./radioInput.vue?vue&type=script&setup=true&lang=js"

import "./radioInput.vue?vue&type=style&index=0&id=79b9c242&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79b9c242"]])

export default __exports__